import { getCornerstoneRuntime } from './getCornerstoneRuntime';
import { canvasToJpegBlob, JPEG_EXPORT_QUALITY } from './jpegConversion';

export async function renderJpegBlobFromImageId(
  imageId: string,
  extensionManager: AppTypes.ExtensionManager
): Promise<Blob> {
  const { cornerstone } = getCornerstoneRuntime(extensionManager);
  const canvas = document.createElement('canvas');

  await cornerstone.utilities.loadImageToCanvas({
    canvas,
    imageId,
    thumbnail: false,
    physicalPixels: true,
  });

  return canvasToJpegBlob(canvas, JPEG_EXPORT_QUALITY);
}
